import { SecondaryColor } from 'stories/Button.stories';

const JoinAlmabetter = () => {
  return (
    <div className="mb-10 flex flex-col items-center justify-center gap-y-12 py-20">
      <div className="flex flex-col items-center gap-y-2">
        <h2 className="font-satoshi-bold">Join AlmaBetter</h2>
        <p className="text-body text-center font-satoshi-medium">
          We are building an A team of passionate engineers, product managers, business &amp; growth
          hustlers and ops ninjas.
        </p>
      </div>
      <img src="/assets/images/About us Page/Group 1000002297@3x.png" alt="" />
      <a href="https://angel.co/company/almabetter/jobs" target="_blank" rel="noopener noreferrer">
        <SecondaryColor label={'Explore Career Opportunities'} size={'2xl'} captalCase />
      </a>
    </div>
  );
};

export default JoinAlmabetter;
